import ArrowRightIcons from '@/icons/ArrowRightIcons'
import React from 'react'
import { Link } from 'react-router-dom'
import { Typogaphy } from 'vnetwork-ui'

interface CardMinimizeProps {
    iconColor: { color: string }
    className?: string
    icon?: React.ReactNode
    label: string
    value?: number
    href?: string
}
const CardMinimize: React.FC<CardMinimizeProps> = ({
    className,
    iconColor,
    icon,
    label,
    href,
    value,
}) => {
    return (
        <div
            className={`flex items-center justify-between bg-white px-4 py-2 rounded-lg ${className}`}
        >
            <div className="flex items-center gap-2">
                <div
                    className="w-6 h-6 flex items-center justify-center rounded-full"
                    style={{ backgroundColor: `${iconColor?.color}26` }}
                >
                    <div style={{ color: iconColor.color }} className="w-4 h-4">
                        {icon}
                    </div>
                </div>
                <Typogaphy className="text-sm font-medium text-primary">
                    {label}
                </Typogaphy>
            </div>
            <div className="flex items-center gap-4">
                <Typogaphy className="text-sm font-semibold text-black">
                    {value}
                </Typogaphy>
                {!!href && (
                    <Link to={href} replace>
                        <ArrowRightIcons className="text-[#C1DBFF] w-4 h-4 hover:text-primary transition-colors duration-200" />
                    </Link>
                )}
            </div>
        </div>
    )
}

export default CardMinimize
